import { render, staticRenderFns } from "./InternalLink.vue?vue&type=template&id=f318b05a&scoped=true&"
import script from "./InternalLink.vue?vue&type=script&lang=js&"
export * from "./InternalLink.vue?vue&type=script&lang=js&"
import style0 from "./InternalLink.vue?vue&type=style&index=0&id=f318b05a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f318b05a",
  null
  
)

export default component.exports